<template>
    <header>
      <i class="iconfont icon-arrow"
         @click="goBack"
         v-if="goBackShow"></i>
      <img src="@/assets/img/logo.png" alt="">
    </header>
</template>

<script>
    export default {
        name: "wit-header",
        data(){
            return{
              goBackShow:true
            }
        },
        watch:{
          "$route.path":{
            handler(){
              if(this.$route.path==='/'){
                this.goBackShow=false
              }else {
                this.goBackShow=true
              }
            },
            //将立即以表达式的当前值触发回调
            immediate: true,
          }
        },
        methods:{
          goBack(){
            this.$router.go(-1)
          },


        },
      created(){


      }
    }
</script>

<style scoped lang="scss">
@import "../../assets/css/global.scss";
header{
  width: 100%;
  background: $color-bg-a;
  height: (88rem/$base);
  min-height:  (88rem/$base); //解决切换动画中header高度探索问题
  display: flex;
  justify-content: center;
  align-items: center;
  >img{
      display: block;
      width: (96rem/$base);
      height: (44rem/$base);
  }
  .icon-arrow{
    width: (40rem/$base);
    height: (74rem/$base);
    line-height: (74rem/$base);
    position: absolute;
    transform: rotate(180deg);
    left: (10rem/$base);
    font-size: (42rem/$base);
  }
}
</style>
